"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgSpeakerOn = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_SPEAKER-ON", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M1.223 5.006 4 4.516 9.417.112a.473.473 0 0 1 .767.251 26.068 26.068 0 0 1 .289 1.433l.004.024C10.735 3.294 11 5.436 11 8c0 2.564-.265 4.706-.523 6.18l-.004.024a30.318 30.318 0 0 1-.289 1.433.473.473 0 0 1-.767.25L4 11.485l-2.777-.49a.671.671 0 0 0-.088-.008c-.327-.015-.625-.193-.739-.501C.218 10.004 0 9.175 0 8c0-1.175.218-2.003.396-2.485.114-.308.412-.486.74-.5a.676.676 0 0 0 .087-.01Zm.872 1.868A6.29 6.29 0 0 0 2 8c0 .455.041.83.095 1.126l2.767.488L8.68 12.72C8.856 11.45 9 9.84 9 8c0-1.84-.144-3.448-.319-4.72l-3.82 3.106-2.766.488ZM14.283 12.953c-.34.431-.975.426-1.364.037-.392-.392-.382-1.025-.056-1.475A5.973 5.973 0 0 0 14 8a5.973 5.973 0 0 0-1.137-3.515c-.325-.45-.336-1.083.056-1.475.389-.389 1.024-.394 1.364.037A7.966 7.966 0 0 1 16 8c0 1.87-.642 3.59-1.717 4.953Z" }))); };
exports.default = SvgSpeakerOn;
